var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_864_2662",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.140137 9C0.140137 4.02944 4.16957 0 9.14014 0C14.1107 0 18.1401 4.02944 18.1401 9C18.1401 13.9706 14.1107 18 9.14014 18C4.16957 18 0.140137 13.9706 0.140137 9Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.140137 9C0.140137 4.02944 4.16957 0 9.14014 0C14.1107 0 18.1401 4.02944 18.1401 9C18.1401 13.9706 14.1107 18 9.14014 18C4.16957 18 0.140137 13.9706 0.140137 9Z",
    fill: "#3FDD78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14014 14C6.37871 14 4.14014 11.7614 4.14014 9H-3.85986C-3.85986 16.1797 1.96044 22 9.14014 22V14ZM14.1401 9C14.1401 11.7614 11.9016 14 9.14014 14V22C16.3198 22 22.1401 16.1797 22.1401 9H14.1401ZM9.14014 4C11.9016 4 14.1401 6.23858 14.1401 9H22.1401C22.1401 1.8203 16.3198 -4 9.14014 -4V4ZM9.14014 -4C1.96044 -4 -3.85986 1.8203 -3.85986 9H4.14014C4.14014 6.23858 6.37871 4 9.14014 4V-4Z",
    fill: "#FEFEFE",
    mask: "url(#path-1-inside-1_864_2662)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.9a428aaadf966fc44270255273535e60.svg";
export { ForwardRef as ReactComponent };